'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Button, Checkbox, Row } from 'react-bootstrap';
const Moment = require('moment');
const uuid = require('uuid');
import DatePicker from 'react-datepicker';
const get = require('lodash/get');
const orderBy = require('lodash/orderBy');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const ExportsUtil = require('../../util/ExportsUtil');
const AnalyticsActions = require('../../actions/AnalyticsActions');
const ServerRequest = require('../../actions/request');
const AnalyticsStore = require('../../stores/AnalyticsStore');
import ErrorBox from '../common/ErrorBox';
import SuccessBox from '../common/SuccessBox';
import LoadingSpinner from '../loading/LoadingSpinner';
import LoadingWithCancel from '../loading/LoadingWithCancel';
import WithProjectActivities from '../DataHOCs/WithProjectActivities';
import { defaultTableHeaderRowRenderer } from 'react-virtualized';

const propTypes = {
    onClose: PropTypes.func.isRequired,
    project: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name: PropTypes.string.isRequired,
    }).isRequired,
    channel: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        channel_permissions: PropTypes.object.isRequired,
        user_permissions: PropTypes.object.isRequired,
    }).isRequired,
    activityStoreState: PropTypes.shape({
        initialized: PropTypes.bool.isRequired,
        activities: PropTypes.array.isRequired,
    }).isRequired,
    show: PropTypes.bool,
};

const defaultProps = {
    show: true,
};

class ProjectActivitiesAnalyticsModal extends React.Component {
    constructor(props) {
        super(props);

        this.pollTaskManager = new ServerRequest.PollTaskManager();

        this.getStartDate = this.getStartDate.bind(this);
        const analyticsStoreState = AnalyticsStore.getState();
        const projActTotals = analyticsStoreState.projectActivitiesRangeTotals[props.project.id] || null;
        let startDate;
        let endDate;
        let retrievedStartDate = null;
        let retrievedEndDate = null;
        const storeStartDate = get(analyticsStoreState.projectActivitiesRangeTotalsDates, [props.project.id, 'startDate']);
        if (!storeStartDate) {
            // startDate = this.getStartDate(Moment().subtract(1, 'M').toDate(), props.project);
            startDate = Moment().subtract(1, 'Y').month(0).date(1).toDate();
        }
        else {
            startDate = Moment(storeStartDate).toDate();
            if (!!projActTotals) {
                retrievedStartDate = Moment(storeStartDate);
            }
        }

        const storeEndDate = get(analyticsStoreState.projectActivitiesRangeTotalsDates, [props.project.id, 'endDate']);
        if (!storeEndDate) {
            // endDate = new Date();
            endDate = Moment().subtract(1, 'Y').month(11).date(31).toDate();
        }
        else {
            endDate = Moment(storeEndDate).toDate();
            if (!!projActTotals) {
                retrievedEndDate = Moment(storeEndDate);
            }
        }

        this.state = {
            // fatalError: null,
            getAnalyticsError: null,
            getAnalyticsActionId: null,
            projActTotals: projActTotals,
            pendingGetAnalytics: analyticsStoreState.projectActivitiesRangeTotalsPending, // an operation which has been started, may not be for this project
            startDate: startDate, // Date
            endDate: endDate, // Date
            retrievedStartDate: retrievedStartDate, // Moment
            retrievedEndDate: retrievedEndDate, // Moment
        };

        
        this.onStartDateChange = this.onStartDateChange.bind(this);
        this.onEndDateChange = this.onEndDateChange.bind(this);
        this.onUpdateDateRange = this.onUpdateDateRange.bind(this);
        this.onExport = this.onExport.bind(this);
        this.unsubscribes = [AnalyticsStore.listen(this.onAnalyticsStoreChange.bind(this))];
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
        this.pollTaskManager.abandonTasks();
    }

    onAnalyticsStoreChange(newState) {
        let additionalState = {
            pendingGetAnalytics: newState.projectActivitiesRangeTotalsPending,
        };
        if (newState.action.id === this.state.getAnalyticsActionId) {
            if (!newState.action.error) {
                additionalState = {
                    ...additionalState,
                    getAnalyticsActionId: null,
                    projActTotals: newState.projectActivitiesRangeTotals[this.props.project.id],
                    retrievedStartDate: Moment(newState.projectActivitiesRangeTotalsDates[this.props.project.id].startDate),
                    retrievedEndDate: Moment(newState.projectActivitiesRangeTotalsDates[this.props.project.id].endDate),
                }
            }
            else {
                additionalState = {
                    ...additionalState,
                    getAnalyticsActionId: null,
                    getAnalyticsError: newState.action.error
                };
            }
        }

        this.setState({ ...additionalState });
    }

    getStartDate(currentStartDate, project) {
        // if current start date is earlier than the project creation date, return project creation date (Date)
        // note TODO: it is possible that a project may have been created and older activities moved into the project, so double check if this is valid
        let projectCreateDate = Moment(project.created_at).toDate();
        if (currentStartDate < projectCreateDate) {
            return projectCreateDate;
        }

        return currentStartDate;
    }

    onStartDateChange(date) {
        this.setState({ startDate: date });
    }

    onEndDateChange(date) {
        this.setState({ endDate: date });
    }

    onUpdateDateRange() {
        const analyticsStoreState = AnalyticsStore.getState();
        if (
            !!analyticsStoreState.projectActivitiesRangeTotals[this.props.project.id]
            && !!analyticsStoreState.projectActivitiesRangeTotalsDates[this.props.project.id]
            && analyticsStoreState.projectActivitiesRangeTotalsDates[this.props.project.id].startDate === Moment(this.state.startDate).format('YYYY-MM-DD')
            && analyticsStoreState.projectActivitiesRangeTotalsDates[this.props.project.id].endDate === Moment(this.state.endDate).format('YYYY-MM-DD')
        ) { // this data is already loaded in the client
            this.setState({
                projActTotals: analyticsStoreState.projectActivitiesRangeTotals[this.props.project.id],
                startDate: Moment(analyticsStoreState.projectActivitiesRangeTotalsDates[this.props.project.id].startDate).toDate(),
                endDate: Moment(analyticsStoreState.projectActivitiesRangeTotalsDates[this.props.project.id].endDate).toDate(),
                retrievedStartDate: Moment(analyticsStoreState.projectActivitiesRangeTotalsDates[this.props.project.id].startDate),
                retrievedEndDate: Moment(analyticsStoreState.projectActivitiesRangeTotalsDates[this.props.project.id].endDate),
            });
        }
        else {
            if (!!this.state.getAnalyticsActionId || !!this.state.pendingGetAnalytics) {
                return; // fetch only one at a time
            }

            const getAnalyticsActionId = uuid.v4();
            if (this.state.getAnalyticsActionId) {
                this.pollTaskManager.cancelAction(this.state.getAnalyticsActionId);
            }
            this.setState({
                    getAnalyticsActionId: getAnalyticsActionId,
                    getAnalyticsError: null,
                    retrievedStartDate: null,
                    retrievedEndDate: null,
                }, () => {
                    AnalyticsActions.getProjectActivitiesRangeTotals(
                        getAnalyticsActionId,
                        {
                            channelId: this.props.channel.id,
                            projectId: this.props.project.id,
                            startDate: Moment(this.state.startDate),
                            endDate: Moment(this.state.endDate)
                        }, this.pollTaskManager
                    );
                });
        }
    }

    cancelGetAnalytics=()=>{
        if (this.state.getAnalyticsActionId) {
            this.pollTaskManager.cancelAction(this.state.getAnalyticsActionId);
            // this.setState({getAnalyticsActionId: null});
        }
    }

    onExport() {
        if (!this.state.projActTotals) return;
        
        const self = this;
        const tableArr = [];
        const headerRow = [
            Strings['en'].analytics.overview.export.CSV_HEAD_ACT_NAME,
            Strings['en'].analytics.overview.export.CSV_HEAD_ASSN_CREATED,
            Strings['en'].analytics.overview.export.CSV_HEAD_ASSN_ACTIVE,
            Strings['en'].analytics.overview.export.CSV_HEAD_STARTED_ATT,
            Strings['en'].analytics.overview.export.CSV_ACTIVE_STUD
        ];
        tableArr.push(headerRow);
        orderBy(this.props.activityStoreState.activities, act => act.meta_data.title).forEach((act) => {
            const data = self.state.projActTotals[act.id];
            if (!data) {
                console.warn('Missing data for act ID', act.id);
            }
            else {
                const attRow = [];
                attRow.push(ExportsUtil._escapeCommas(act.meta_data.title));
                attRow.push(data.assignmentTotals);
                attRow.push(data.nonEmptyAssnCount);
                attRow.push(data.attemptsTotals);
                attRow.push(data.activeStudentsTotal);
                tableArr.push(attRow);
            }
        });

        const csvContent = ExportsUtil._generateCsvText(tableArr);
        const fileName = `${self.props.project.name}_${self.state.retrievedStartDate.format('YYYY-MM-DD')}-${self.state.retrievedEndDate.format('YYYY-MM-DD')}.csv`;
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
        if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, fileName);
        }
        else {
            let link = document.createElement("a");
            const csvUrl = URL.createObjectURL(blob);
            link.setAttribute('href', csvUrl);
            link.setAttribute("download", fileName);
            link.innerHTML= 'Download CSV file';
            document.body.appendChild(link); // Required for FF
            link.click();
            document.body.removeChild(link);
        }
    }

    render() {
        const self = this;

        return (
            <Modal
                show={this.props.show}
                enforceFocus={false}
                backdrop={false}
                animation={false}
                keyboard
                size="lg"
                onHide={this.props.onClose}
            >
                <Modal.Header closeButton onHide={this.props.onClose}>
                    <Modal.Title>{this.props.project.name} - {Strings['en'].analytics.overview.export.PROJ_ACT_EXPORT_HEADING}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <ErrorBox error={this.state.getAnalyticsError} />
                    <Form className="margin-bottom-lg">
                        <Row>
                            <div className="col-12 col-sm-6 margin-bottom-lg">
                                <label className="label-form margin-right-sm">
                                    {Strings['en'].common.START_DATE}
                                </label>
                                <DatePicker
                                    className="margin-right-md"
                                    selected={this.state.startDate}
                                    onChange={this.onStartDateChange}
                                    minDate={Moment(Globals.date.SERVICE_DATE_MIN_YYYY_MM_DD).toDate()}
                                    maxDate={this.state.maxDate}
                                />
                            </div>
                            <div className="col-12 col-sm-6 margin-bottom-lg">
                                <label className="label-form margin-right-sm">
                                    {Strings['en'].common.END_DATE}
                                </label>
                                <DatePicker
                                    className="margin-right-md"
                                    selected={this.state.endDate}
                                    onChange={this.onEndDateChange}
                                    minDate={this.state.startDate}
                                    maxDate={new Date()}
                                />
                            </div>
                            <div className="col-12">
                                <Button
                                    disabled={!!this.state.getAnalyticsActionId || !!this.state.pendingGetAnalytics}
                                    onClick={this.onUpdateDateRange}
                                >
                                    {Strings['en'].analytics.overview.export.RETRIEVE_DATA}
                                </Button>
                                {(!!this.state.pendingGetAnalytics) ?
                                        (!!this.state.getAnalyticsActionId) ?
                                        <span className="margin-left-lg">
                                            <LoadingWithCancel className="margin-right-sm" 
                                                loadingText={Strings['en'].analytics.overview.export.DATA_RETRIEVING_SELF} 
                                                onCancel={this.cancelGetAnalytics}/>
                                        </span>
                                        :
                                        <span className="margin-left-lg"><LoadingSpinner className="margin-right-sm" />{Strings['en'].analytics.overview.export.DATA_RETRIEVING_OTHER}</span>
                                    :
                                    null
                                }
                            </div>
                        </Row>
                    </Form>
                    {(!!this.state.projActTotals && !this.state.getAnalyticsActionId) &&
                        <SuccessBox>
                            {Strings['en'].analytics.overview.export.DATA_RETRIEVED_RANGE} {Moment(this.state.retrievedStartDate).format('YYYY/MM/DD')} - {Moment(this.state.retrievedEndDate).format('YYYY/MM/DD')}
                            <p className="margin-top-sm">{Strings['en'].analytics.overview.export.EXPORT_GUIDANCE}</p>
                            <div className="text-align-center margin-top-lg">
                                <Button
                                    onClick={this.onExport}
                                >
                                    {Strings['en'].common.EXPORT_CSV}
                                </Button>
                            </div>
                        </SuccessBox>
                    }
                </Modal.Body>
            </Modal>
        );
    }
}

ProjectActivitiesAnalyticsModal.propTypes = propTypes;
ProjectActivitiesAnalyticsModal.defaultProps = defaultProps;

export default WithProjectActivities(ProjectActivitiesAnalyticsModal);